// extracted by mini-css-extract-plugin
module.exports = {"outer-wrapper":"BoxCta_outer-wrapper__bK2j4","main":"BoxCta_main__A0E6G","search-fade-in":"BoxCta_search-fade-in__Dg61r"};